import axios from "axios";
import React, { useEffect, useState } from "react";
import { BiArrowBack } from "react-icons/bi";
import { useNavigate } from "react-router-dom";

const AddOtherPricing = () => {
  const API_BASE_URL = process.env.REACT_APP_API_BASEURL;
  const navigate = useNavigate();
  const [category, setCategory] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [topics, setTopics] = useState([]);
  const [topicsId, setTopicsId] = useState("");
  const [price, setPrice] = useState();

  const getCategory = () => {
    axios
      .get(`${API_BASE_URL}/category`)
      .then((resp) => {
        console.log(resp);
        const { data } = resp.data;
        setCategory(data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getCategory();
  }, []);

  const getAllTopics = () => {
    axios
      .get(`${API_BASE_URL}/topics?categoryId=${categoryId}`)
      .then((response) => {
        // console.log(response);
        setTopics(response.data?.topics);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  useEffect(() => {
    getAllTopics();
  }, [categoryId]);

  const handleAddOtherPricing = () => {
    navigate("/exam-notes-pricing/add-other-pricing");
  };
  const handleViewAllOtherPricing = () => {
    navigate("/exam-notes-pricing/all-other-pricing");
  };
  const handleGoBack = () => {
    navigate("/exam-notes-pricing");
  };
  const payload = {
    topicId: topicsId,
    price,
    type: "other",
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    axios
      .post(`${API_BASE_URL}/admin/pricing/exam-notes`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      })
      .then((result) => {
        console.log(result);
        alert("Other Notes Price Added.");
        setPrice("");
        setCategoryId("");
        setTopicsId("");
        navigate("/exam-notes-pricing/all-other-pricing");
      })
      .catch((error) => {
        console.log(error);
        alert("Error while Adding Price.");
      });
  };
  return (
    <div id="exam-school-notes-inner-wrapper">
      <div className="main-header">
        <BiArrowBack
          onClick={handleGoBack}
          className="left-arrow-icon"
          style={{
            cursor: "pointer",
            display: "flex",
            fontSize: "25px",
            color: "#000",
          }}
        />
        <div className="exam-header-div">
          <h5>Other Notes Pricing</h5>
          <div className="exam-btn-group">
            <button className="addNewNoteBtn" onClick={handleAddOtherPricing}>
              + Add Other Pricing
            </button>
            <button
              className="viewAllNotesBtn"
              onClick={handleViewAllOtherPricing}
            >
              All Pricing
            </button>
          </div>
        </div>

        <div className="form-container" id="form">
          <h4 className="note-detail">Add Other Note Price</h4>
          <form onSubmit={handleSubmit} className="note-detail-form">
            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Category</label>
              <select
                className="new-chapter-dropdown"
                value={categoryId}
                onChange={(e) => setCategoryId(e.target.value)}
                required
              >
                <option value="">-Select Category-</option>
                {category &&
                  category.map((item, idx) => (
                    <option key={idx} value={item?._id}>
                      {item?.category}
                    </option>
                  ))}
              </select>
            </div>

            <div className="new-chapter-form-group">
              <label className="new-chapter-label">Category Topic</label>
              <select
                className="new-chapter-dropdown"
                value={topicsId}
                onChange={(e) => setTopicsId(e.target.value)}
                required
              >
                <option value="">-Select Topic-</option>
                {topics &&
                  topics.map((item, idx) => (
                    <option key={idx} value={item._id}>
                      {item?.topic}
                    </option>
                  ))}
              </select>
            </div>

            <div className="input-group">
              <label className="label">Note Price</label>
              <input
                type="text"
                className=""
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                placeholder="Enter Note Price"
                required
              />
            </div>

            <div className="form1-btns">
              <button className="btn-save">Save</button>
              <button
                type="button"
                className="btn-cancel"
                onClick={handleGoBack}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddOtherPricing;
